export default "__VITE_ASSET__02c04d9d__"